import { FC, ReactNode } from 'react'
import { Card } from '@mui/material'

import { FLEXIBLE } from '@constants'

type CardContainerProps = {
  children: ReactNode
}

const CardContainer: FC<CardContainerProps> = ({ children }) => {
  return (
    <Card
      sx={{
        ...FLEXIBLE,
        boxShadow: 'none',
        // borderRadius: 0,
        '.MuiCardContent-root:last-child': { p: 0 },
        background: theme => theme.palette.background.formCardContainer,
        border: theme => theme.palette.border.formCardContainer,
      }}
    >
      {children}
    </Card>
  )
}

export default CardContainer
